export default __webpack_public_path__ + "1ab16d8626fbcb27778831ea3963242b.png";